import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {DoubleControl, firstNestedSymbolControl} from '../../../models/uiArtefakt';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';
import {NgForm} from '@angular/forms';
import {ValidationService} from '../../../services/validation.service';
import {UiUpdateService} from '../../../services/ui-update.service';
import {ShellConfigService} from '../../../services/shell-config.service';
import {UIAusrichtung} from '../../../models/uiAusrichtung';
import {ISymbol} from '@lv1871/core';
import {EventService} from '../../../services/event.service';
import {StageConfigService} from '../../../services/stage-config.service';

@Component({
    selector: 'lv-double',
    templateUrl: './double.component.html',
    styleUrls: ['./double.component.scss'],
    standalone: false
})
export class DoubleComponent implements OnInit, AfterViewInit {
  @ViewChild(NgForm, {static: true})
  private _ngForm;

  public isDisabled: boolean = false;
  public stepsize: number;
  public uiAusrichtung: UIAusrichtung;
  public nestedSymbol: ISymbol;
  public showInfotextCollapsable: boolean = false;
  public model: string = null;
  public autocomplete: string;

  private _uiArtefakt: DoubleControl;

  constructor(private _validationService: ValidationService, private _eventService: EventService,
              private _shellConfigService: ShellConfigService, private _uiUpdateService: UiUpdateService,
              private _stageConfigService: StageConfigService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): DoubleControl {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: DoubleControl) {
    this._uiArtefakt = uiArtefakt;
    if (uiArtefakt.WertEingabe != null && !this.model) {
      this.model = (this._uiArtefakt.WertEingabe + '').replace('.', ',');
    }
    this.isDisabled = this._uiArtefakt?.Darstellungsart === UIDarstellungsart.DISABLED;
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  public infotextCollapsableChange(event) {
    this.showInfotextCollapsable = event;
  }

  public ngOnInit(): void {
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
    this.autocomplete = this._stageConfigService.getInputAutocomplete();
    this.nestedSymbol = firstNestedSymbolControl(this.uiArtefakt.UIArtefakt);
    this._validationService.registerForm(this.uiArtefakt, this._ngForm);
  }

  public changeValue(value: any, isValid: boolean) {
    if (value + '' === this.model + '') {
      return;
    }
    if (!value && value !== 0) {
      this.model = null;
      this.uiArtefakt.WertEingabe = null;
      this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
      return;
    }
    if (!isValid) {
      return;
    }
    this.model = value;
    this.uiArtefakt.WertEingabe = parseFloat(value.replace(',', '.'));
    this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
  }

  public onBlur(value: any) {
    if (!!value) {
      this.model = (value + '').replace('.', ',');
    } else {
      this.model = null;
    }
    if(!!this._uiArtefakt.ReferenzIdentifikator){
      this._eventService.refIdentTouchedOrDirty$.next(this._uiArtefakt.ReferenzIdentifikator);
    }
  }
}
